export default {
    deviceId: state => state.deviceId,
    uuid: state => state.uuid,
    userInfo: state => state.userInfo,
    noticeInfo: state => state.noticeInfo,
    recents: state => state.recents,
    historyGames: state => state.historyGames,
    homeGames: state => state.homeGames,
    isLogin: state => !!state.uuid,
    configInfo: state => state.configInfo,
}


// WEBPACK FOOTER //
// ./src/store/getters.js